import ButtonLink from "./button-link";
import classes from "../classes";
import expandable from "./higher-order/expandable";
import React from "react";

function ButtonMenuItem({ children, onClick, selected }) {
  return (
    <li className="btn_item">
      <ButtonLink
        className={classes({
          "btn_link": true,
          "btn_link--is-selected": selected
        })} onClick={onClick}>
        {children}
      </ButtonLink>
    </li>
  );
}

export default expandable(({ block, children, disabled, expanded, onChange, selected, short, toggle }) => {
  /* eslint-disable react/no-array-index-key */
  var items = children.map((child, i) => (
    <ButtonMenuItem key={i} onClick={(e) => { e.stopPropagation(); toggle(); onChange(i); }} selected={i === (selected || 0)}>
      {child}
    </ButtonMenuItem>
  ));
  /* eslint-enable react/no-array-index-key */

  var clickHandler = (e) => {
    e.stopPropagation();
    if (!disabled) {
      toggle();
    }
  };
  return (
    <div
      className={classes({
        "btn": true,
        "btn--is-disabled": disabled,
        "btn--menu": true,
        "btn--small": !block,
        "btn--menu--is-open": expanded,
        "btn--menu--is-short": short,
        "btn--is-block": block
      })} onClick={clickHandler}>
      <div className="btn_label">
        {children[selected] || children[0]}
      </div>

      <ul className="btn_list">
        {items}
      </ul>
    </div>
  );
});
